import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { ISearchFilter } from '@shared/interface/search.interface';
import { IsampleList } from '@shared/list/sample.list';
import { switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpCondVentaService {
  private http = inject(HttpClient);
  private urlApi = environment.apiUrl + '/cond-sale';

  list = [];

  init() {
    this.findAll({order: 'cvt_Desc', direction: 'ASC', limit: 1000}).subscribe((resp) => {
      this.list = resp.data;
    });
  }

  getListCondVta(id: number | string) {
  const resp: IsampleList[] = [];

  Object.values(this.list).forEach((l: any) => {
    const isEnabled = l.is_enable === true;
    const isSelected = l.id === id || l.cvt_Cod === id;

    if (isEnabled || isSelected) {
      resp.push({ id: l.cvt_Cod, name: l.cvt_Desc });
    }
  });

  return resp;
}

  findAll(filter: ISearchFilter) {
    return this.http.post<any>(`${this.urlApi}/all`, { ...filter });
  }

  findList(data: any) {
    return this.http.get<any>(`${this.urlApi}/list`, { params: { text: data, filterEnable: true } });
  }

  updateIsEnable(is_enable: boolean, ids: any[]) {
    return this.http
      .post<any>(`${this.urlApi}/update-is-enable`, { is_enable, ids })
      .pipe(
        switchMap(() =>
          this.findAll({ order: 'cvt_Desc', direction: 'ASC', limit: 1000 })
        ),
        tap((resp) => {
          this.list = resp.data;
        })
      );
  }
}
